export default "__VITE_ASSET__CntkrAMc__"